/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IValidatePhoneResponse {
  /** Статус подтверждения телефона **/
  status: EStatus;
  /** Время до следующей отправки кода подтверждения **/
  confirmTimeout?: TValidatePhoneResponse_ConfirmTimeout;
}

export enum EStatus {
  /** Проверка пропущена **/
  'Skipped' = 'skipped',
  /** В процессе проверки **/
  'InProgress' = 'inProgress',
  /** Проверка успешно завершена **/
  'Ok' = 'ok',
  /** Введен неправильный код **/
  'Error' = 'error',
}
export type TValidatePhoneResponse_ConfirmTimeout = null | number;
